<template>
  <v-expand-transition>
    <v-row>
      <v-col cols="12" :md="mdCols">
        <v-select
          outlined
          :items="achievementKindUnits"
          item-text="name"
          item-value="id"
          clearable
          v-model="prtf_achievement_unit_id"
          :color="$store.state.achievement.side_color"
          label="Ед. измерения"
          dense
          class="rounded-xl"
          no-data-text="Степень достижения отсутсвует"
          :rules="achievementLevelRules"
        >
          <template #item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle v-show="data.item.score !== 0">{{data.item.score}} бал.</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" :md="mdCols" v-if="achievementKindSubunits.length !== 0">
        <v-select outlined
                  :items="achievementKindSubunits"
                  item-text="name"
                  dense
                  item-value="id"
                  clearable
                  v-model="prtf_achievement_subunit_id"
                  :color="$store.state.achievement.side_color"
                  label="Критерий"
                  class="rounded-xl"
                  no-data-text="Степень дост  ижения отсутсвует"
                  :rules="achievementUnitRules"
        >
          <template #item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>{{data.item.score}} бал.</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" :md="mdCols">
        <date-picker/>
      </v-col>
    </v-row>
  </v-expand-transition>
</template>

<script>
import _ from "lodash";
import {mapMutations, mapState} from "vuex";
import DatePicker from "../../DatePicker/DatePicker";
import {createHelpers} from "vuex-map-fields";

const {mapFields} = createHelpers({
  getterType: 'achievement/getPayloadAchievement',
  mutationType: 'achievement/updatePayloadAchievement',
});

export default {
  name: "CriteriaAchievementTextField",

  components: {
    DatePicker,
  },

  data() {
    return {
      units: [],
      achievementLevelRules: [
        v=> !!v || 'Выберите уровень достижения',
      ],
      achievementUnitRules: [
        v=> !!v || 'Выберите критерий достижения',
      ],
    };
  },

  props: {
    achievementKind: Object,
  },

  watch: {

  },

  computed: {
    ...mapFields([
      'prtf_achievement_unit_id',
      'prtf_achievement_subunit_id',
    ]),

    ...mapState({
      payload: state => state.achievement.payload,
    }),

    achievementKindUnits() {
      const achievementId = this.payload.prtf_achievement_kind_id;

      if (_.isNil(achievementId) || _.isNil(this.achievementKind)) return []
      if(this.achievementKind.units.length === 0) return []

      return this.achievementKind.units;
    },

    achievementKindSubunits() {
      const achievementId = this.payload.prtf_achievement_kind_id;

      if (_.isNil(achievementId) || _.isNil(this.prtf_achievement_unit_id) || this.achievementKindUnits.length === 0) return []
      const achievementUnit =  _.find(this.achievementKindUnits, {"id": this.prtf_achievement_unit_id}) || []

      if ((achievementUnit?.subunits?.length || 0) === 0) return [];

      return achievementUnit.subunits;
    },

    mdCols() {
      if(_.isNil(this.achievementKindSubunits)) return '6'
      if (this.achievementKindSubunits.length !== 0) return '4'
      else return '6'
    },
  },

  methods: {
    ...mapMutations({
      setAchievementData: 'achievement_form/setAchievementData',
    }),

    textSelectUnit(item) {
      if(item.data.score !== 0) return `${item.data.name} - ${item.data.score} бал.`
      else return `${item.data.name}`
    },

    textSelectSubunit(item) {
      return `${item.data.name} - ${item.data.score} бал.`
    },

  },
}
</script>

<style scoped>

</style>